import React from 'react';
import { Check, Loader2 } from 'lucide-react';

const ProgressBlock = ({ message, percentage }) => {
  const isComplete = percentage >= 100;

  return (
    <div className={`flex items-center space-x-3 p-4 rounded-lg border ${
      isComplete
        ? 'bg-green-50 border-green-200'
        : 'bg-blue-50 border-blue-200'
    }`}>
      {isComplete ? (
        <Check className="w-5 h-5 text-green-600" />
      ) : (
        <Loader2 className="w-5 h-5 text-blue-600 animate-spin" />
      )}
      <div className="flex-1">
        <div className="flex items-center justify-between mb-2">
          <span className={`text-sm font-medium ${
            isComplete ? 'text-green-900' : 'text-blue-900'
          }`}>
            {isComplete ? 'Complete!' : message}
          </span>
          <span className={`text-sm ${
            isComplete ? 'text-green-600' : 'text-blue-600'
          }`}>
            {percentage}%
          </span>
        </div>
        <div className={`w-full rounded-full h-2 ${
          isComplete ? 'bg-green-200' : 'bg-blue-200'
        }`}>
          <div
            className={`h-2 rounded-full transition-all duration-500 ease-out ${
              isComplete ? 'bg-green-600' : 'bg-blue-600'
            }`}
            style={{ width: `${Math.min(percentage, 100)}%` }}
          />
        </div>
      </div>
    </div>
  );
};

export default ProgressBlock;
